<mat-sidenav-container class="help-drawer-container" [hasBackdrop]="!isSideMode()">
  <mat-sidenav
    position="end"
    class="help-sidenav"
    [mode]="isSideMode() ? 'side' : 'over'"
    [opened]="contextualHelpService.isOpen()"
    (closedStart)="contextualHelpService.close()">
    <div class="help-drawer-header" [class.is-scrolled]="isContentScrolled()">
      <div class="help-drawer-header-title">
        <div class="help-icon-orb">
          <mat-icon>help_outline</mat-icon>
        </div>
        <div class="help-drawer-header-text">
          <h3>{{ 'help.title' | transloco }}</h3>
          @if (breadcrumb(); as crumb) {
            @if (!isBrowsing()) {
              <span class="help-breadcrumb">{{ crumb.category }} / {{ crumb.label }}</span>
            }
          }
        </div>
      </div>
      <div class="help-drawer-header-actions">
        <button
          mat-icon-button
          [class.is-active]="isBrowsing()"
          [matTooltip]="'help.browseTooltip' | transloco"
          [attr.aria-pressed]="isBrowsing()"
          (click)="toggleBrowsing()">
          <mat-icon>{{ isBrowsing() ? 'search_off' : 'search' }}</mat-icon>
        </button>
        <button mat-icon-button (click)="contextualHelpService.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    @if (isBrowsing()) {
      <div class="help-index">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="help-index-search">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="search"
            autocomplete="off"
            [ngModel]="searchQuery()"
            [placeholder]="'help.searchPlaceholder' | transloco"
            (ngModelChange)="searchQuery.set($event)" />
        </mat-form-field>

        <div class="help-index-results">
          @for (group of groupedIndex(); track group.category) {
            <div class="help-index-group">
              <span class="help-index-group-label">{{ group.categoryLabelKey | transloco }}</span>
              @for (item of group.entries; track item.entry.key) {
                <button
                  type="button"
                  class="help-index-item"
                  [class.is-current]="item.entry.key === contextualHelpService.currentHelpKey()"
                  (click)="openFromIndex(item.entry.key)">
                  {{ item.label }}
                </button>
              }
            </div>
          } @empty {
            <div class="help-index-empty">
              <mat-icon>search_off</mat-icon>
              <p>{{ 'help.searchNoResults' | transloco }}</p>
            </div>
          }
        </div>
      </div>
    } @else {
      @if (isRoleFallback()) {
        <mat-button-toggle-group
          class="role-toggle-group"
          [value]="contextualHelpService.currentHelpKey()"
          (change)="contextualHelpService.open($event.value)">
          <mat-button-toggle value="role-organizer">
            <mat-icon>event</mat-icon>
            {{ 'contestRole.organizer' | transloco }}
          </mat-button-toggle>
          <mat-button-toggle value="role-judge">
            <mat-icon>gavel</mat-icon>
            {{ 'contestRole.judge' | transloco }}
          </mat-button-toggle>
          <mat-button-toggle value="role-dancer">
            <mat-icon>directions_run</mat-icon>
            {{ 'contestRole.dancer' | transloco }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      }

      <div
        class="help-drawer-content"
        tabindex="0"
        role="region"
        [class.spotlight-inert]="!isSpotlightUsable()"
        (click)="onMarkdownClick($event)"
        (keydown.enter)="onMarkdownClick($event)"
        (keydown.space)="onMarkdownClick($event)"
        (scroll)="onContentScroll($event)">
        @if (contextualHelpService.loading() && !contextualHelpService.content()) {
          <div class="help-loading">
            <mat-spinner diameter="24" />
          </div>
        } @else if (contextualHelpService.content()) {
          @if (!isSpotlightUsable()) {
            <div class="help-spotlight-inert-note">
              <mat-icon>info_outline</mat-icon>
              <span>{{ 'help.spotlightInertNote' | transloco }}</span>
            </div>
          }
          <div class="markdown-content-wrapper" [class.is-visible]="isContentVisible()">
            <markdown [data]="contextualHelpService.content()" />
          </div>
        } @else if (contextualHelpService.loadError()) {
          <div class="help-error">
            <mat-icon>error_outline</mat-icon>
            <p>{{ 'help.loadErrorMessage' | transloco }}</p>
            <button mat-stroked-button (click)="contextualHelpService.retry()">
              <mat-icon>refresh</mat-icon>
              {{ 'common.retry' | transloco }}
            </button>
          </div>
        }
      </div>

      @if (contextualHelpService.currentHelpKey()) {
        <div class="help-debug-footer">{{ contextualHelpService.currentHelpKey() }}.{{ activeLang() }}.md</div>
      }
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content />
  </mat-sidenav-content>
</mat-sidenav-container>
